import React, { useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../../../store/hooks'
import { MEETING_SUMMARY_HEADER_PRESETS } from '../HeaderPresets'
import {
  MeetingSummaryHeaderPreset,
  selectMeetingSummaryAgentDisplayedPresets,
  setMeetingSummaryDisplayedPresets,
} from '../../../../../../../store/meetingSummaryAgent/meetingSummaryAgent'
import { selectSelectedMeetingTemplate } from '../../../../../../../store/meetingSummary/meetingTemplates'
import { Button } from '../../../../../../../components/Button/Button'
import classNames from 'classnames'
import { TrackEvent, useTracking } from '../../../../common/tracking'

interface MeetingSummaryHeaderPresetButtonProps {
  headerPreset: MeetingSummaryHeaderPreset
}

export const MeetingSummaryHeaderPresetButton: React.FC<MeetingSummaryHeaderPresetButtonProps> = ({ headerPreset }) => {
  const dispatch = useAppDispatch()
  const { tracked } = useTracking()

  const orderedPresets = MEETING_SUMMARY_HEADER_PRESETS.map((p) => p.aiFeaturePresetId)
  const displayedPresets = useAppSelector(selectMeetingSummaryAgentDisplayedPresets)
  const selectedMeetingTemplate = useAppSelector(selectSelectedMeetingTemplate)
  const [isPinned, setIsPinned] = useState<boolean>(displayedPresets.includes(headerPreset.aiFeaturePresetId))

  const { aiFeaturePresetId, label, icon } = headerPreset

  const meetingTemplatePreset = selectedMeetingTemplate?.presets.find((preset) => preset.aiFeaturePresetId === aiFeaturePresetId)

  if (!meetingTemplatePreset) {
    if (displayedPresets.includes(aiFeaturePresetId)) {
      dispatch(setMeetingSummaryDisplayedPresets(displayedPresets.filter((p) => p !== aiFeaturePresetId)))
    }
    return null
  }

  const _handleDisplayPreset = (aiFeaturePresetId: string) => {
    if (displayedPresets.includes(aiFeaturePresetId)) {
      dispatch(setMeetingSummaryDisplayedPresets(displayedPresets.filter((p) => p !== aiFeaturePresetId)))
      setIsPinned(false)
    } else {
      dispatch(
        setMeetingSummaryDisplayedPresets([...displayedPresets, aiFeaturePresetId].sort((a, b) => orderedPresets.indexOf(a) - orderedPresets.indexOf(b))),
      )
      setIsPinned(true)
    }
  }

  const handleDisplayPreset = tracked(
    _handleDisplayPreset,
    { eventName: TrackEvent.MEETING_SUMMARY_AGENT_FEATURE_PIN_CLICKED },
    {
      eventDetailsExtractor: (aiFeaturePresetId: string) => {
        return { action: displayedPresets.includes(aiFeaturePresetId) ? 'closed' : 'opened', feature: aiFeaturePresetId }
      },
    },
  )

  return (
    <Button
      variant='header'
      className={classNames('px-2 py-1 button-medium', { 'bg-black zocks-border-color-black': isPinned })}
      onClick={() => handleDisplayPreset(aiFeaturePresetId)}
    >
      <div className='d-flex gap-2 align-items-center py-1 zocks-px-0.75 zocks-border-0.25 bg-black text-white'>
        <i className={`bi ${icon}`} />
        {label}
      </div>
      <i className={classNames('bi bi-pin-angle', { 'text-white': isPinned })} />
    </Button>
  )
}
